import { useContext, useEffect, useState } from "react";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import PoFormContext from "../../../../contexts/poFormContext";
import { createConfigValidation } from "../../../../helpers/validation/validation";

const ObservationRecommendations = () => {
    const { poForm, setPoForm } = useContext(PoFormContext);  
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["zalecenia"]
            if (errorMsg !== '') {
                setErrorTipText(errorMsg);
                setReload(!reload);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])
    
    const onChangeInput = (event: string) => {
        var form: any = Object.assign({}, poForm);
        if (form !== null && form.protocolAttributes) form.protocolAttributes.zalecenia = event;
        setPoForm(form);
    }
    
    // Observation Recommendations
    var textAreaPropsObservationRecommendations: TextAreaFieldProps = {
        labelName: 'Zalecenia co do dalszych obserwacji',
        textAreaPlaceholder: poForm.protocolAttributes?.zalecenia == null || poForm.protocolAttributes?.zalecenia === '' ? 'Dodaj opis' : '',
        value: poForm.protocolAttributes?.zalecenia,
        textareaSharedProps: {
            className: poForm.protocolAttributes?.zalecenia == null || poForm.protocolAttributes?.zalecenia === '' ? 'body-txt-medium-sec-gray' : 'largeFormTextarea body-txt-large',
            style: {
                minHeight: '190px'
            }
        },
        configValidation: createConfigValidation("zalecenia", true),
        disabled: false,
        setValue: onChangeInput,
        pristine: true,
        validationError: poForm.config?.isValid !== undefined ? !poForm.config?.isValid : false,
        tipText: errorTipText,
        reload: reload,
        dynamicResize: true
    }

    return (
        <div>
            <h2>3. Zalecenia co do dalszych obserwacji</h2>
            <TextAreaField {...textAreaPropsObservationRecommendations}/>
        </div>
    )

}

export default ObservationRecommendations;